import script from "./header.vue?vue&type=script&lang=ts&setup=true"
export * from "./header.vue?vue&type=script&lang=ts&setup=true"

import "./header.vue?vue&type=style&index=0&id=3ff4a07a&lang=scss&scoped=true"

import exportComponent from "/Users/zhangjun/Desktop/project/envo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff4a07a"]])

export default __exports__